<template>
	<div class="dashboard-content row m-0 andon-qc-dashboard">
		<div v-if="isLoading" class="loading-data">
			<b-spinner variant="light" label="Get Data"></b-spinner> loading...
		</div>
		<ColumnViewer v-for="(item, index) in dataChartSelected" :key="index" idName="column3" :className="`column3 col-4 ${isDataItemCheck(index) ? '' : 'd-none'}`">
			<div id="card4" class="div-card4">
				<CardViewer className="card4">
					<TextViewer idName="text5" :value="item.name" className="text5" />
				</CardViewer>
			</div>
			<div id="card6" class="div-card6">
				<CardViewer className="card6">
					<div id="card7" class="card7-parent">
						<CardViewer className="card7">
							<TextViewer idName="text8" value="Sum Qty NG" className="text8" />
							<TextViewer idName="text9" :value="item.data.sumQtyNG" className="text9" />
						</CardViewer>
					</div>
					<TextViewer idName="text11" value="Most Defect" className="text11" />
					<PieChartViewer v-if="item.data.mostDefectPercentage != null &&  item.data.mostDefectPercentage != undefined" idName="piechart10" :chartOptions="piechart10Options"
						:dataChart="item.data.mostDefectPercentage" className="piechart10" chartLabel="name"
						chartValue="percentage"
						:height="185"
						/>
				</CardViewer>
			</div>
			<div id="card12" class="div-card12">
				<CardViewer className="card12">
					<TextViewer idName="text13" value="Top 5 Most Part Problem" className="text13" />
					<BarChartViewer idName="barchart14" :chartOptions="barchart14Options" className="barchart14"
						:dataChart="item.data.mostPartProblem" chartLabel="part_number" chartValue="sum_qty_ng"
						:height="170" :decimalNumber="0"
						/>
				</CardViewer>
			</div>
			<div id="card15" class="div-card15">
				<CardViewer className="card15">
					<TextViewer idName="text16" value="NG Ratio" className="text16" />
					<DoughnutChartViewer idName="doughnutchart17" :chartOptions="doughnutchart17Options"
						className="doughnutchart17"
						:dataChart="item.data.ngRatio" chartLabel="name" chartValue="count"
						:height="170"
						 />
					<div class="d-flex justify-content-center ratio-txt">
						<h4 class="text-white font-weight-bold">{{ item.data.ngRatio != null ? item.data.ngRatio[0].count + "%" : "0%" }}</h4>
					</div>
				</CardViewer>
			</div>
		</ColumnViewer>
	</div>
</template>
<style lang="scss" scoped>
@import '../../assets/scss/dashboard-page.scss';
@import '../../assets/dashboardcss/andonqc.scss';

#app-container {
	overflow: hidden;
}

.div-card4 {
	min-height: 4vh;
	height: 4vh;
}

.div-card6, .div-card12, .div-card15 {
	min-height: 32vh;
	height: 32vh;
}

.ratio-txt {
	margin-top: -15px;
}

</style>
<script>
import ListViewer from '@/components/dashboard/ListViewer';
import ColumnViewer from '@/components/dashboard/ColumnViewer';
import CardViewer from '@/components/dashboard/CardViewer';
import TextViewer from '@/components/dashboard/TextViewer';
import PieChartViewer from '@/components/dashboard/PieChartViewer';
import BarChartViewer from '@/components/dashboard/BarChartViewer';
import DoughnutChartViewer from '@/components/dashboard/DoughnutChartViewer';

export default {
	components: {
		ListViewer, ColumnViewer, CardViewer, TextViewer, PieChartViewer, BarChartViewer, DoughnutChartViewer
	},
	data() {
		return {
			piechart10Options: {
				"legend": true
			},
			barchart14Options: {},
			doughnutchart17Options: {
				"legend": false
			},
			isLoading: false,
			dataChart: [],
			isDataItem: true,
			andonInterval: {},
		}
	},
	mounted() {
		this.getAndonQCData();
		this.getAndonInterval();
	},
	methods: {
		getAndonQCData() {
			let this_ = this;
			this.isLoading = true;
			return this.$http.get(process.env.VUE_APP_API_URL + `DataSource/getandonqcdata`).then(result => {
				if (result != null) {
					this_.dataChart = result.data;
					if (this_.andonInterval != null) {
						clearInterval(this_.andonInterval);
						this_.runAutoChange();
					}
				}
				this_.isLoading = false;
				return true;
			}).catch(function (error) {
				this_.isLoading = false;
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		},
		getAndonInterval() {
			let this_ = this;
			return this.$http.get(process.env.VUE_APP_API_URL + `DataSource/getandonrefreshinterval`).then(result => {
				if (result != null) {
					if(result.data != null) {
						if (result.data.interval != null && result.data.interval != undefined
							 && result.data.interval > 0) {
							this_.runAutorefresh(result.data.interval);
						}
					}
				}
				return true;
			}).catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		},
		runAutorefresh(interval) {
			let this_ = this;
			setInterval(() => {
				this_.getAndonQCData(this.processTypeSelected);
			}, (1000 * 60 * interval));
		},
		runAutoChange() {
			let this_ = this;
			this.andonInterval = setInterval(() => {
				this_.isDataItem = !this_.isDataItem;
			}, (15000));
		},
		isDataItemCheck(index) {
			if (index < 3 && !this.isDataItem) {
				return false;
			}
			return true;
		}
	},
	beforeDestroy() {
      clearInterval(this.andonInterval);
    },
	computed: {
		dataChartItems() {
			if (this.dataChart.length > 2) {
				return this.dataChart.slice(0, 3);
			}
			return [];
		},
		dataChartQCs() {
			if (this.dataChart.length > 5) {
				return this.dataChart.slice(3, 6);
			}
			return [];
		},
		dataChartSelected() {
			return this.dataChart;
			/*if (this.isDataItem) {
				return this.dataChartItems;	
			} else {
				return this.dataChartQCs;
			}*/
		}
	}
}
</script>